import { useRecord } from "./useRecord";

export function useLabel(labelId?: string | null) {
  return useRecord("tag", labelId, { name: "useLabel" });
}
